import type { ReactElement } from "react";

/** The position is still OPEN at the broker, but the operator has asked for
 * it to be exited and the exchange was shut at the time.
 *
 * This banner exists because the alternative was a lie: before 2026-08-19 an
 * after-hours force exit reported success and the row went CLOSED, while the
 * broker still held the position (basket a846d018 in prod, 2026-08-18). The
 * operator plans the next session off this card, so it says plainly that
 * nothing has been sold yet. */
export function QueuedExitBanner({
  queuedExitAt,
}: Readonly<{ queuedExitAt: string | null }>): ReactElement | null {
  if (queuedExitAt === null) return null;
  return (
    <div className="mt-3 flex items-start gap-2 rounded border border-warning/40 bg-warning/10 p-2 text-xs">
      <i className="ti ti-clock-pause mt-0.5 text-warning" />
      <span>
        <span className="font-medium">Exit queued for the next open.</span>{" "}
        <span className="text-ink-secondary">
          Nothing has been sent to the broker — this position is still open and still at risk.
        </span>
      </span>
    </div>
  );
}
